import { Component, Mixins } from 'vue-property-decorator'
import applicationStore from '@/store/modules/applications/applicationStore'
import APP_CONST from '@/constants/AppConst'
import { updateProgramDetails } from '@/services/create-user/userService'
import MissingGaurdianPopup from './scholarDetails/MissingGaurdianPopup/MissingGaurdianPopup.vue'
import UIkit from 'uikit'
import AccountSettings from '@/mixins/accountSettings.mixin'
import APP_UTILITIES from '@/utilities/commonFunctions'
import commonEntry from '@/store/modules/commonEntry'
import ProgressButton from '@/commoncomponents/progressButton/progressButton.vue'
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue'

@Component({
  components: {
    BouncingPreloader,
    'missing-gaurdian-popup': MissingGaurdianPopup,
    'progress-button': ProgressButton
  }
})
export default class ScholarContainer extends Mixins(AccountSettings) {
  public hoverText: string = ''
  public hoverId: number = 0
  public hoverStyleObj: any = {}
  public duplicateErrorResponse: any = ''
  public isNavigationDetected: boolean = false
  public editForm: string = ''
  public routeSelection: string = ''
  public apiResponseCode: number = 0
  public isValid: boolean = true
  public progressBtn: boolean = true
  APP_CONST = APP_CONST

  get selectedScholar() {
    return applicationStore.selectedScholar
  }

  get scholarName() {
    return applicationStore.selectedScholar
      ? `${applicationStore.selectedScholar.firstName} ${applicationStore.selectedScholar.lastName}`
      : ''
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor
  }

  get editMode() {
    return applicationStore.isFormEditModeActive || applicationStore.isFormProgramEditModeActive
  }

  get editScholarDetails() {
    return applicationStore.scholarDetails
  }

  get editGuardianDetails() {
    return applicationStore.guardianDetails
  }

  get editEmergencyDetails() {
    return applicationStore.emergencyDetails
  }

  get editAuthorizePickups() {
    return applicationStore.authorizeDetails
  }

  get editSiteDetails() {
    return applicationStore.editSiteDetails
  }

  get initialGuardianObj() {
    let guardianDetails: any = ''
    if (localStorage.getItem('initialGuardianDetails')) {
      guardianDetails = localStorage.getItem('initialGuardianDetails')
      guardianDetails = JSON.parse(guardianDetails)
    }
    return guardianDetails
  }

  get initialEmergencyObj() {
    let emergencyDetails: any = ''
    if (localStorage.getItem('initialEmergencyDetails')) {
      emergencyDetails = localStorage.getItem('initialEmergencyDetails')
      emergencyDetails = JSON.parse(emergencyDetails)
    }
    return emergencyDetails
  }

  get initialScholarObj() {
    let scholarDetails: any = ''
    if (localStorage.getItem('initialScholarDetails')) {
      scholarDetails = localStorage.getItem('initialScholarDetails')
      scholarDetails = JSON.parse(scholarDetails)
    }
    return scholarDetails
  }

  get initialAuthorizeObj() {
    let authorize: any = ''
    if (localStorage.getItem('initialAuthorizedDetails')) {
      authorize = localStorage.getItem('initialAuthorizedDetails')
      authorize = JSON.parse(authorize)
    }
    return authorize
  }

  get initialProgramObj() {
    let program: any = ''
    if (localStorage.getItem('initialSiteData')) {
      program = localStorage.getItem('initialSiteData')
      program = JSON.parse(program)
    }
    return program
  }

  get isFormDirty() {
    if (applicationStore.isFormEditModeActive) {
      return (
        JSON.stringify(this.editEmergencyDetails) != JSON.stringify(this.initialEmergencyObj) ||
        JSON.stringify(this.editGuardianDetails) != JSON.stringify(this.initialGuardianObj) ||
        JSON.stringify(this.editScholarDetails) != JSON.stringify(this.initialScholarObj)
      )
    } else if (applicationStore.isFormProgramEditModeActive) {
      return (
        JSON.stringify(this.editAuthorizePickups) != JSON.stringify(this.initialAuthorizeObj) ||
        JSON.stringify(this.editSiteDetails) != JSON.stringify(this.initialProgramObj)
      )
    }
    return false
  }

  get programDetail() {
    return applicationStore.programDetail
  }

  get programsList() {
    return applicationStore.programsList
  }

  get deletedAuthorizePickup() {
    return applicationStore.deletedAuthorizePickup
  }

  get isProgramDetailsByScholarLoading() {
    return applicationStore.isProgramDetailsByScholarLoading
  }

  get isLoadingGetAddedScholarData() {
    return applicationStore.isLoadingGetAddedScholarData
  }

  mounted() {
    if (localStorage.getItem('selectedGuid')) {
      let selectedGuid: any = localStorage.getItem('selectedGuid')
        ? localStorage.getItem('selectedGuid')
        : ''
      selectedGuid = JSON.parse(selectedGuid)
      const guid = selectedGuid
      applicationStore.getScholarData(guid).then(() => {
        applicationStore.mutateEditFormMode(false)
        applicationStore.mutateEditProgramFormMode(false)
      })
    }
  }

  enableEditForm() {
    applicationStore.mutateDuplicateEmail('')
    this.editForm = 'edit'
    if (this.$route.path == '/scholar/details') {
      applicationStore.mutateEditFormMode(true)
    }
    if (this.$route.path == '/scholar/programs') {
      applicationStore.mutateEditProgramFormMode(true)
    }
  }

  callHover(value: string, event: any, id?: number) {
    this.hoverText = value
    if (id) {
      this.hoverId = id
    }
    const boundBox = event && event.target && event.target.getBoundingClientRect()
    const coordX = boundBox.left
    const coordY = boundBox.top
    this.hoverStyleObj = {
      position: 'fixed',
      top: (coordY + 30).toString() + 'px',
      left: coordX.toString() + 'px'
    }
  }

  callHoverOut() {
    this.hoverText = ''
    this.hoverId = 0
  }

  updateScholar(from?: string) {
    if (from == 'modal') {
      this.progressBtn = false
    } else {
      this.progressBtn = true
    }
    if (this.$route.path === '/scholar/programs') {
      this.isNavigationDetected = false
      const formRef: any = this.$refs
      if (formRef && !formRef.scholarDetails.validateFormProgramAuthorize()) {
        this.submitAuthorizeAndProgram()
      }
    } else if (this.$route.path === '/scholar/details') {
      this.isNavigationDetected = false
      const formRef: any = this.$refs

      this.editEmergencyDetails.forEach((ele: any, index: number) => {
        if (ele.status.value === '') {
          if (
            ele.firstName.value ||
            ele.lastName.value ||
            ele.relation.value ||
            ele.phone.value ||
            ele.phoneType.value
          ) {
            ele.status.value = 0
          } else if (
            ele.firstName.value == '' &&
            ele.lastName.value == '' &&
            ele.relation.value == '' &&
            ele.phone.value == '' &&
            ele.phoneType.value == ''
          ) {
            ele.status.value = ''
          }
        }
      })
      let activeGuardianLength = 0
      this.editGuardianDetails.forEach((ele: any) => {
        if (ele.status.value && ele.status.value != 3) {
          activeGuardianLength += 1
        }
      })

      this.editGuardianDetails.forEach((val: any, index: number) => {
        if (activeGuardianLength == 1) {
          if (
            !val.firstName.value &&
            !val.lastName.value &&
            !val.email.value &&
            !val.phone.value &&
            !val.relation.value &&
            !val.phoneType.value &&
            !val.secondaryPhone.value &&
            !val.secondaryPhoneType.value &&
            !val.address1.value &&
            !val.address2.value &&
            !val.city.value &&
            !val.state.value &&
            !val.homeLanguage.value
          ) {
            if (UIkit.modal('#missing-gaurdian-popup')) {
              UIkit.modal('#missing-gaurdian-popup').show()
            }
          }
        }
      })
      if (!formRef.scholarDetails.validateForm()) {
        this.submitScholar()
      }
      APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_DETAILS.saveScholarChanges)
    }
  }

  cancelChanges(route: any) {
    this.isNavigationDetected = false
    this.$router.push(route)
    applicationStore.mutateDeletedForAuthorize([])
    localStorage.removeItem('initialSiteData')
    localStorage.removeItem('initialAuthorizedDetails')
    localStorage.removeItem('initialEmergencyDetails')
    localStorage.removeItem('initialScholarDetails')
    localStorage.removeItem('initialGuardianDetails')
  }

  navigateToRoute(route: string) {
    this.routeSelection = route
    if (this.isFormDirty) {
      this.isNavigationDetected = true
    } else {
      this.cancelChanges(this.routeSelection)
    }
  }

  submitScholar() {
    const guardianArray: any = []
    const emergencyArray: any = []
    this.editGuardianDetails.forEach((item: any, index: number) => {
      const guardianData = {
        scholarId: this.selectedScholar.guardianDetails[index]
          ? this.selectedScholar.guardianDetails[index].scholarId
          : null,
        id: this.selectedScholar.guardianDetails[index]
          ? this.selectedScholar.guardianDetails[index].id
          : 0,
        accountId: this.selectedScholar.guardianDetails[0].accountId,
        programId: this.selectedScholar.guardianDetails[0].programId,
        familyPortalStatus: this.selectedScholar.guardianDetails[index]
          ? this.selectedScholar.guardianDetails[index].familyPortalStatus
          : 0,
        internalUseProfileStatus: this.selectedScholar.guardianDetails[index]
          ? this.selectedScholar.guardianDetails[index].internalUseProfileStatus
          : 0,
        guid: this.selectedScholar.guardianDetails[index]
          ? this.selectedScholar.guardianDetails[index].guid
          : null,
        primaryGuardian: item.primaryGuardian.value,
        firstName: item.firstName.value,
        lastName: item.lastName.value,
        relation: item.relation.value,
        email: item.email.value,
        phone: item.phone.value ? item.phone.value.replace(/\D/g, '') : '',
        phoneType: item.phoneType.value == '' ? '' : item.phoneType.value,
        secondaryPhone: item.secondaryPhone.value
          ? item.secondaryPhone.value.replace(/\D/g, '')
          : '',
        secondaryPhoneType:
          item.secondaryPhoneType.value == '' ? '' : item.secondaryPhoneType.value,
        homeLanguage: item.homeLanguage.value,
        status: item.status.value
          ? item.status.value
          : this.selectedScholar.guardianDetails[index]
            ? item.status
            : APP_CONST.ONE,
        userId: this.selectedScholar.guardianDetails[index]
          ? this.selectedScholar.guardianDetails[index].userId
          : 0,
        address: {
          guid:
            this.selectedScholar.guardianDetails[index] &&
            this.selectedScholar.guardianDetails[index].address
              ? this.selectedScholar.guardianDetails[index].address.guid
              : null,
          address1: item.address1.value,
          address2: item.address2.value,
          state: item.state.value,
          city: item.city.value && item.city.value.trimLeft().length > 0 ? item.city.value : '',
          zip: item.zip.value == '' ? '' : item.zip.value
        }
      }
      if (item.phone.value != '' || (item.firstName.value != '' && item.lastName.value != '')) {
        guardianArray.push(guardianData)
      }
    })

    this.editEmergencyDetails.forEach((item: any, index: number) => {
      const emergencyData = {
        scholarId: this.selectedScholar.emergencyContacts[index]
          ? this.selectedScholar.emergencyContacts[index].scholarId
          : null,
        id: this.selectedScholar.emergencyContacts[index]
          ? this.selectedScholar.emergencyContacts[index].id
          : 0,
        guid:
          this.selectedScholar.emergencyContacts && this.selectedScholar.emergencyContacts[index]
            ? this.selectedScholar.emergencyContacts[index].guid
            : null,
        callOrder: item.callOrder.value ? item.callOrder.value : '',
        firstName:
          item.status.value === ''
            ? APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME
            : item.firstName.value
              ? item.firstName.value
              : '',
        lastName:
          item.status.value === ''
            ? APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME
            : item.lastName.value
              ? item.lastName.value
              : '',
        relation: item.relation.value ? item.relation.value : '',
        phone:
          item.status.value === ''
            ? APP_CONST.EMERGENCY_CONTACT_EMPTY_PHONE
            : item.phone.value
              ? item.phone.value.replace(/\D/g, '')
              : '',
        phoneType: item.phoneType.value == '' ? '' : item.phoneType.value,
        status:
          item.status.value === ''
            ? APP_CONST.EMERGENCY_CONTACT_DELETE_STATUS
            : item.status.value
              ? item.status.value
              : 0
      }
      if (
        item.firstName.value == '' &&
        item.lastName.value == '' &&
        item.relation.value == '' &&
        item.phone.value == '' &&
        item.phoneType.value == ''
      ) {
        emergencyArray.push(emergencyData)
      } else if (
        item.phone.value != '' ||
        (item.firstName.value != '' && item.lastName.value != '')
      ) {
        emergencyArray.push(emergencyData)
      }
    })

    const programDetails = {
      grade: this.editScholarDetails[APP_CONST.ZERO].grade.value
        ? this.editScholarDetails[APP_CONST.ZERO].grade.value
        : '',
      tShirtSize: this.editScholarDetails[APP_CONST.ZERO].tShirtSize.value
        ? this.editScholarDetails[APP_CONST.ZERO].tShirtSize.value
        : ''
    }

    const scholarData: any = {
      id: this.selectedScholar.id,
      guid: this.selectedScholar.guid ? this.selectedScholar.guid : null,
      programId: this.selectedScholar.programDetails.programId,
      siteId: this.selectedScholar.siteDetails[0] ? this.selectedScholar.siteDetails[0].siteId : '',
      accountId: this.selectedScholar.accountId,
      schoolStudentId: this.editScholarDetails[APP_CONST.ZERO].schoolStudentId.value,
      schoolName: this.editScholarDetails[APP_CONST.ZERO].schoolName.value,
      firstName: this.editScholarDetails[APP_CONST.ZERO].firstName.value,
      lastName: this.editScholarDetails[APP_CONST.ZERO].lastName.value,
      nickname: this.editScholarDetails[APP_CONST.ZERO].nickName.value,
      gender: this.editScholarDetails[APP_CONST.ZERO].gender.value,
      raceEthnicity:
        this.editScholarDetails[APP_CONST.ZERO].ethnicity.value == ''
          ? ''
          : this.editScholarDetails[APP_CONST.ZERO].ethnicity.value,
      birthDate: JSON.stringify(this.editScholarDetails[APP_CONST.ZERO].birthDate.value).replace(
        /['"]+/g,
        ''
      ),
      age: this.editScholarDetails[APP_CONST.ZERO].age.value,
      grade: this.editScholarDetails[APP_CONST.ZERO].grade.value
        ? this.editScholarDetails[APP_CONST.ZERO].grade.value
        : '',
      tShirtSize: this.editScholarDetails[APP_CONST.ZERO].tShirtSize.value
        ? this.editScholarDetails[APP_CONST.ZERO].tShirtSize.value
        : '',
      email: this.editScholarDetails[APP_CONST.ZERO].email.value,
      homeLanguage: this.editScholarDetails[APP_CONST.ZERO].homeLanguage.value,
      phone: this.editScholarDetails[APP_CONST.ZERO].phone.value
        ? this.editScholarDetails[APP_CONST.ZERO].phone.value.replace(/\D/g, '')
        : '',
      phoneType:
        this.editScholarDetails[APP_CONST.ZERO].phoneType.value == ''
          ? ''
          : this.editScholarDetails[APP_CONST.ZERO].phoneType.value,
      address: {
        guid: this.selectedScholar.address ? this.selectedScholar.address.guid : null,
        address1: this.editScholarDetails[APP_CONST.ZERO].address1.value,
        address2: this.editScholarDetails[APP_CONST.ZERO].address2.value,
        state: this.editScholarDetails[APP_CONST.ZERO].state.value,
        city:
          this.editScholarDetails[APP_CONST.ZERO].city.value &&
          this.editScholarDetails[APP_CONST.ZERO].city.value.trimLeft().length > 0
            ? this.editScholarDetails[APP_CONST.ZERO].city.value
            : '',
        zip:
          this.editScholarDetails[APP_CONST.ZERO].zip.value == ''
            ? ''
            : this.editScholarDetails[APP_CONST.ZERO].zip.value
      },
      scholarMedical: {
        guid: this.selectedScholar.scholarMedical ? this.selectedScholar.scholarMedical.guid : 0,
        epiPen:
          this.editScholarDetails[APP_CONST.ZERO].epiPen.value == ''
            ? ''
            : this.editScholarDetails[APP_CONST.ZERO].epiPen.value,
        asthmaInhaler:
          this.editScholarDetails[APP_CONST.ZERO].asthmaInhaler.value == ''
            ? ''
            : this.editScholarDetails[APP_CONST.ZERO].asthmaInhaler.value,
        allergies: this.editScholarDetails[APP_CONST.ZERO].allergies.value,
        medication: this.editScholarDetails[APP_CONST.ZERO].medication.value,
        insuranceProvider: this.editScholarDetails[APP_CONST.ZERO].insuranceProvider.value
      },
      guardianDetails: guardianArray,
      emergencyContacts: emergencyArray,
      siteDetails: this.selectedScholar.siteDetails ? this.selectedScholar.siteDetails : {},
      programDetails: this.selectedScholar.programDetails
        ? { ...this.selectedScholar.programDetails, ...programDetails }
        : {},
      scholarLearning: {
        iep: this.editScholarDetails[APP_CONST.ZERO].iep.value,
        llp: this.editScholarDetails[APP_CONST.ZERO].llp.value,
        specialEducation: this.editScholarDetails[APP_CONST.ZERO].specialEducation.value
      }
    }

    scholarData.birthDate =
      scholarData.birthDate !== '' ? scholarData.birthDate.replace(/ - /g, '/') : ''
    if (this.progressBtn) {
      this.apiResponseCode = APP_CONST.ZERO
      this.isValid = false
    }
    applicationStore.updateScholarData(scholarData).then((response: any) => {
      if (response.status == APP_CONST.RESPONSE_400) {
        if (this.progressBtn) {
          this.apiResponseCode = APP_CONST.RESPONSE_400
          this.isValid = true
        }
        applicationStore.mutateDuplicateErrorResponse(
          response.data.data ? response.data.data : response.data
        )
        if (
          response.data.message == 'Email already exists.' ||
          response.data.message ==
            'We cannot process your request, you are trying to insert duplicate emails in guardian'
        ) {
          applicationStore.mutateDuplicateEmail(response.data.data.email)
        }
      } else {
        if (this.progressBtn) {
          this.apiResponseCode = APP_CONST.RESPONSE_200
          this.isValid = true
        }
        applicationStore.mutateDuplicateErrorResponse('')
        applicationStore.mutateEditFormMode(false)
        localStorage.removeItem('initialEmergencyDetails')
        localStorage.removeItem('initialScholarDetails')
        localStorage.removeItem('initialGuardianDetails')
        const user_id = APP_UTILITIES.getCookie(APP_CONST.USER_ID)
        if (user_id) {
          commonEntry.fetchUserDetails(parseInt(user_id))
        }
      }
    })
  }

  submitAuthorizeAndProgram() {
    const authorizeData: any = []
    if (this.deletedAuthorizePickup) {
      this.editAuthorizePickups.push(...this.deletedAuthorizePickup)
    }
    this.editAuthorizePickups.forEach((item: any, index: number) => {
      const authorizePickup = {
        firstName: item.firstName.value ? item.firstName.value : '',
        guid: item.guid.value ? item.guid.value : null,
        lastName: item.lastName.value ? item.lastName.value : '',
        phone: item.phone.value ? item.phone.value.replace(/\D/g, '') : '',
        phoneType: item.phoneType.value == 'Select' ? '' : item.phoneType.value,
        pickUpEndDate: item.pickUpEndDate.value ? item.pickUpEndDate.value : '',
        pickUpStartDate: item.pickUpStartDate.value ? item.pickUpStartDate.value : '',
        relation: item.relation.value ? item.relation.value : '',
        status: item.status.value ? item.status.value : ''
      }
      if (item.phone.value != '' || (item.firstName.value != '' && item.lastName.value != '')) {
        authorizeData.push(authorizePickup)
      }
    })

    const updateProgramPayload: any = { scholarId: '', programEditList: [] }
    updateProgramPayload.scholarId = this.selectedScholar.guid
    this.editSiteDetails.forEach((program: any, programIndex: number) => {
      const programDetails: any = { programId: '', siteEditList: [] }
      Object.keys(programDetails).forEach((itemKey: any) => {
        if (program.hasOwnProperty(itemKey)) {
          programDetails[itemKey] = program[itemKey].value
        } else if (itemKey == 'programId') {
          programDetails[itemKey] = this.programsList[programIndex].id
        }
      })
      const innerSite: any = this.editSiteDetails[programIndex]
      innerSite.forEach((site: any, siteIndex: number) => {
        const sitePayload: any = { siteId: '', arrivalPlan: '', dismissalPlan: '' }
        Object.keys(sitePayload).forEach((siteItem: any) => {
          if (site.hasOwnProperty(siteItem)) {
            sitePayload[siteItem] =
              site[siteItem].value && site[siteItem].value != 'Select' ? site[siteItem].value : ''
          } else if (siteItem == 'siteId') {
            sitePayload[siteItem] =
              this.programDetail[programIndex].siteDetailList[siteIndex].siteId
          }
        })
        programDetails.siteEditList.push(sitePayload)
      })
      updateProgramPayload.programEditList.push(programDetails)
    })
    if (this.progressBtn) {
      this.apiResponseCode = APP_CONST.ZERO
      this.isValid = false
    }
    updateProgramDetails(updateProgramPayload).then((response: any) => {
      if (response.status == APP_CONST.RESPONSE_200) {
        if (this.progressBtn) {
          this.apiResponseCode = APP_CONST.RESPONSE_200
          this.isValid = true
        }
        applicationStore.updateAuthorizeData(authorizeData).then((responseAuth: any) => {
          if (responseAuth.status == APP_CONST.RESPONSE_400) {
            applicationStore.mutateDuplicateErrorResponse(responseAuth.data.data)
          } else {
            applicationStore.mutateDuplicateErrorResponse('')
            applicationStore.mutateEditProgramFormMode(false)
            applicationStore.mutateDeletedForAuthorize([])
            localStorage.removeItem('initialSiteData')
            localStorage.removeItem('initialAuthorizedDetails')
          }
        })
      } else {
        if (this.progressBtn) {
          this.apiResponseCode = APP_CONST.RESPONSE_400
          this.isValid = false
        }
      }
    })
  }

  destroyed() {
    applicationStore.mutateScholarData('')
    applicationStore.mutateDocumentArray([])
    applicationStore.mutateScholarDocument({})
    applicationStore.mutateEditFormMode(false)
    applicationStore.mutateEditProgramFormMode(false)
    applicationStore.mutateGetProgramDetails([])
    localStorage.removeItem('initialSiteData')
    localStorage.removeItem('initialAuthorizedDetails')
    localStorage.removeItem('initialEmergencyDetails')
    localStorage.removeItem('initialScholarDetails')
    localStorage.removeItem('initialGuardianDetails')
  }
}
